'use client';

import Loader from '@/components/ui/Loader';
import { PathEnum } from '@/i18n/locale-config';
import { useRouter } from '@/i18n/navigation';
import { useUserStore } from '@/store/useUserStore';
import { useEffect, useState } from 'react';

const SessionProvider = ({ children }: { children: React.ReactNode }) => {
    const { validateSession, refreshSession, logout, user, session } = useUserStore();
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAndRefreshSession = async () => {
            if (!user || !session) {
                router.push(PathEnum.SignIn);
                return;
            }

            const isValid = await validateSession();
            if (!isValid) {
                await refreshSession();

                const refreshedIsValid = await validateSession();
                if (!refreshedIsValid) {
                    logout();
                    router.push(PathEnum.SignIn);
                    return;
                }
            }

            setIsLoading(false);
        };

        checkAndRefreshSession();
    }, [validateSession, refreshSession, logout, user, session, router]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <Loader />
            </div>
        );
    }

    return <>{children}</>;
};

export default SessionProvider;
